import React from 'react';
import {Row, Col, Table } from 'antd';
import { useTranslation } from 'react-i18next';

const MonedaExt = ({monedaExt={}, actual, lastFormDate, forceExpand}) => {
    const { t } = useTranslation();
    const exMonColumns = [
        {
            title: t("messages.aml.currencyType"),
            dataIndex: 'tipoMon'
        },
        {
            title: t("messages.aml.country"),
            dataIndex: 'country'
        },
    ]
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={24}>
                    <Table
                        className={actual && monedaExt.exMonRecords !== actual.exMonRecords && "difference"}
                        columns={exMonColumns}
                        dataSource={monedaExt.exMonRecords}
                        pagination={!forceExpand && monedaExt.exMonRecords?.length > 10 }
                    />
                </Col>
            </Row>
        </div>
    );
};

export default MonedaExt;